var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"global-snackbar"},[_c('div',{staticClass:"toast-notification"},[_c('span',{staticClass:"body-sm"},[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"ml-3 btn-transparent",on:{"click":function($event){_vm.show = false}}},[_c('i',{staticClass:"mdi mdi-close"})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }